import sailsDataProvider from './sailsProvider';
import {fetchUtils} from 'react-admin';

let baseApiUrl = process.env.REACT_APP_BASE_API_URL;

// Set the current hostname for API url if there is no one in env configuration
if (!baseApiUrl) {
  baseApiUrl  = window.location.protocol + '//' + window.location.hostname + ':1337';
}

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  // Add custom header
  options.headers.set('token', localStorage.getItem('token'));
  options.headers.set('timezone', (new Date().getTimezoneOffset()) / (-60));

  return fetchUtils.fetchJson(url, options);
};

export { baseApiUrl };
export default sailsDataProvider(baseApiUrl, httpClient);
